<template>
  <section class="site-footer">
    <div class="container">
      <div class="row">
        <div class="col-md-8 col-sm-12 col-lg-8 col-12">
          <div class="social left">
            <div class="pcg-footer-contact-table">
              <div class="links-logo pb2">
                <div>
                  <a href="http://www.infrastructure-ni.gov.uk/" target="_blank"><img src="@/assets/images/Belfast/Footer/Infra.png" alt="A link to the Department of Infrastructure" class="logo1"/></a>
                  <!-- <br/> -->
                  <!-- <p class="pcg-footer-copyright">Have feedback for the proposed changes? <a href="/site/haveYourSay">Leave Feedback</a></p> -->
                </div>
              </div>
              <div class="links-logo ">
                <div class="grow-50">
                  <p><a href="https://www.translink.co.uk/usingtranslink/introducingglider" target="_blank"><img src="@/assets/images/Belfast/Footer/Glider.png" alt="A link to the Glider website" class="logo2" /></a></p>
                </div>
                <div class="grow-50">
                  <p><a href="https://www.translink.co.uk/" target="_blank"><img src="@/assets/images/Belfast/Footer/Translink.png" alt="A link to the TransLink website" class="logo2"/></a></p>
                </div>
                
              </div>
               <div class="links-logo">
                <div class="grow-50">
                  <p><a href="https://www.atkinsglobal.com/homepage" target="_blank"><img src="@/assets/images/Belfast/Footer/Full_White_Atkins_logo.png" alt="a link to the Atkins Global homepage" style="" class="logo3"/></a></p>
                </div>
                 <div class="grow-50 belfastregioncitydeal">
                  <p><a href="https://www.belfastcity.gov.uk/belfastregioncitydeal" target="_blank"><img src="@/assets/images/Belfast/Footer/belfast_region_city_region_logo.png" alt="a link to the Belfast City Region website." style="" class="logo3"/></a></p>
                </div>
               </div>
              <div class="links-logo">
                <div class="grow-20 gap-after">
                  <p class="pcg-footer-copyright"><a href="https://www.infrastructure-ni.gov.uk/dfi-privacy" class="footer-link" target="_blank">Privacy Policy</a></p> 
                </div>
                <div class="grow-20 gap-after">
                  <p class="pcg-footer-copyright"><a href="https://www.infrastructure-ni.gov.uk/cookies" class="footer-link" target="_blank">Cookies Policy</a></p> 
                </div>

              </div>
              <div class="pcg-footer-copyright">
                © Copyright 2021 Department of Infrastructure. All Rights Reserved.
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-sm-12 col-lg-4 col-12 hide-on-small-and-down">
          <div class="social">
            <div class="pcg-footer-text right">
              <p><a href="/site/homePage" class="footer-link">Home</a></p>
              <p><a href="/site/gliderPhasePage" class="footer-link">BRT Phase 2</a></p>
              <p><a href="/site/optionsPage" class="footer-link">Route Options</a></p>
              <p><a href="/site/webinarPage" class="footer-link">View Webinar</a></p>
              <p><a href="/site/faqPage" class="footer-link">FAQ's</a></p>
              <p><a href="/site/haveYourSay" class="footer-link">Have Your Say</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "site-footer",
};
</script>
 <style lang="scss">

 a.footer-link {
   text-decoration: none;
 }
 a.footer-link:hover {
   text-decoration: none;
 }
 a.footer-link:active {
   text-decoration: none;
 }
 a.footer-link:visited {
   text-decoration: none;
 }

 .belfastregioncitydeal{
   margin-top: 1rem;
 }

// @import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap');
// $font-family: "Roboto";
// .site-footer {
//     .pb4{
//         padding-bottom: 4rem; 
//     }
//     background-color:#06233e;
//     padding: 4rem 0;
//     .row {
//         margin: 0 auto;
//         border-top: 3px solid #472884;
//         padding-top: 4rem;
//     }
//     .links-logo {
//         display: flex;
//         flex-direction: row;
//         // padding-bottom: 4rem;
//         .grow-50{
//             flex-grow:0;
//         flex-basis:50%;
//         }
//         img {
//              display: block;
//             // width: 300px;
//         }
//         ul {
//             margin: 0 auto;
//             padding: 0;
//             padding-left: 10px;
//         }

//         a {
//             color: #fff;
//             &:hover {
//                 text-decoration: underline;
//             }
//         }
//         span{
//             padding-right:2rem;
//         }
//     }
//     .social {
//         .right{
//             text-align: right;
//         }
//         .left{
//             text-align: left;
//         }

//         h4 {
//             font-size: 1.25em;
//             margin-bottom: 15px;
//             color:white
//         }
        
//         a {
//             color: #fff;
//             &:hover {
//                 text-decoration: underline;
//             }
//         }
//         .icons {
//             display: flex;
//             flex-direction: row;
//             flex-wrap: nowrap;
//             align-items: center;
//             justify-content: flex-end;
//             margin-bottom: 24px;

//             a {
//                 display: block;
//                 padding: 0 5px;
//                 &:first-child {
//                     padding-left: 0;
//                 }
//                 &:last-child {
//                     padding-right: 0;
//                 }
//             }
//             img {
//                 width: 45px;
//                 display: block;
//             }
//         }
//         .pcg-footer-copyright {
//             color: #fff;
//             padding: 0 0 0 0;
//             font-family: $font-family;
//             font-weight:300;
//             font-size:14px;
//             line-height:24px;

//         }
//         .pcg-footer-text {
//             color: #fff;
//             padding: 0 0 0 0;
//         }
//     }
// }
 </style>